var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataTrendsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.031,
    height: 618.114,
    viewBox: "0 0 799.031 618.114",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(-560 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782-9720",
    "data-name": "Path 782",
    d: "M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z",
    transform: "translate(675.479 358.778)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 19.105,
    height: 3.371,
    transform: "translate(865.162 842.354)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 19.105,
    height: 3.371,
    transform: "translate(1034.295 842.916)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783-9721",
    "data-name": "Path 783",
    d: "M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945H352.955Z",
    transform: "translate(633.72 321.38)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 193.296,
    height: 5.242,
    transform: "translate(863.43 830.985)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784-9722",
    "data-name": "Path 784",
    d: "M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z",
    transform: "translate(560 209.089)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 760.822,
    height: 429.297,
    transform: "translate(579.547 248.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(662.881 329.557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 149.174,
    height: 113.965,
    rx: 8,
    transform: "translate(445.471)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 134.349,
    height: 102.639,
    transform: "translate(452.884 5.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446-9723",
    "data-name": "Path 3446",
    d: "M693.4,297.7h.053a35.82,35.82,0,0,0,.8-71.491.817.817,0,0,0-.618.214.809.809,0,0,0-.264.592l-.783,69.859a.82.82,0,0,0,.811.827Z",
    transform: "translate(-170.983 -215.901)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447-9724",
    "data-name": "Path 3447",
    d: "M666.346,237.433a1.055,1.055,0,0,1,.74.316l24.049,24.595a1.043,1.043,0,0,1,.3.746l-.375,33.428a1.04,1.04,0,0,1-.34.761,1.056,1.056,0,0,1-.794.276,36.054,36.054,0,0,1-24.382-59.764,1.056,1.056,0,0,1,.762-.357Z",
    transform: "translate(-172.021 -215.577)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448-9725",
    "data-name": "Path 3448",
    d: "M690.469,225.927a1.059,1.059,0,0,1,.72.294,1.04,1.04,0,0,1,.323.769l-.338,30.16a1.05,1.05,0,0,1-1.8.722l-20.986-21.462a1.052,1.052,0,0,1,.057-1.524,36.13,36.13,0,0,1,21.961-8.959Z",
    transform: "translate(-171.689 -215.909)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449-9726",
    "data-name": "Path 3449",
    d: "M679.694,309.958a6.434,6.434,0,1,1-6.361-6.505,6.434,6.434,0,0,1,6.361,6.505Z",
    transform: "translate(-171.725 -213.675)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450-9727",
    "data-name": "Path 3450",
    d: "M697.56,310.158a6.434,6.434,0,1,1-6.361-6.505A6.434,6.434,0,0,1,697.56,310.158Z",
    transform: "translate(-171.21 -213.669)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451-9728",
    "data-name": "Path 3451",
    d: "M715.426,310.358a6.434,6.434,0,1,1-6.361-6.505A6.434,6.434,0,0,1,715.426,310.358Z",
    transform: "translate(-170.696 -213.664)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 149.174,
    height: 113.965,
    rx: 8,
    transform: "translate(443.901 131.901)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 134.349,
    height: 102.639,
    transform: "translate(451.313 137.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 5.578,
    cy: 5.578,
    r: 5.578,
    transform: "translate(468.53 160.142)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452-9729",
    "data-name": "Path 3452",
    d: "M735.314,373.075a3.783,3.783,0,0,1,0,7.566H676.645a3.783,3.783,0,0,1,0-7.566h58.669m0-.927H676.645a4.71,4.71,0,1,0,0,9.419h58.669a4.71,4.71,0,1,0,0-9.419Z",
    transform: "translate(-171.578 -211.696)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453-9730",
    "data-name": "Path 3453",
    d: "M712.406,381.568H668.241a4.71,4.71,0,0,1,0-9.419h44.165a4.71,4.71,0,0,1,0,9.419Z",
    transform: "translate(-171.82 -211.696)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 5.578,
    cy: 5.578,
    r: 5.578,
    transform: "translate(468.53 183.306)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454-9731",
    "data-name": "Path 3454",
    d: "M735.314,395.59a3.783,3.783,0,0,1,0,7.566H676.645a3.783,3.783,0,0,1,0-7.566h58.669m0-.927H676.645a4.71,4.71,0,0,0,0,9.419h58.669a4.71,4.71,0,1,0,0-9.419Z",
    transform: "translate(-171.578 -211.047)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455-9732",
    "data-name": "Path 3455",
    d: "M729.084,404.083H668.241a4.71,4.71,0,0,1,0-9.419h60.843a4.71,4.71,0,0,1,0,9.419Z",
    transform: "translate(-171.82 -211.047)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 5.578,
    cy: 5.578,
    r: 5.578,
    transform: "translate(468.53 206.469)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456-9733",
    "data-name": "Path 3456",
    d: "M735.314,418.105a3.783,3.783,0,0,1,0,7.566H676.645a3.783,3.783,0,0,1,0-7.566h58.669m0-.927H676.645a4.71,4.71,0,0,0,0,9.419h58.669a4.71,4.71,0,1,0,0-9.419Z",
    transform: "translate(-171.578 -210.398)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457-9734",
    "data-name": "Path 3457",
    d: "M692.949,426.6H668.241a4.71,4.71,0,0,1,0-9.419h24.708a4.71,4.71,0,0,1,0,9.419Z",
    transform: "translate(-171.82 -210.398)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 405.085,
    height: 245.866,
    rx: 8,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 388.981,
    height: 230.626,
    transform: "translate(8.052 7.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458-9735",
    "data-name": "Path 3458",
    d: "M532.581,408.413H249.021a.887.887,0,0,1-.887-.887V271.616a.887.887,0,1,1,1.775,0V406.639H532.581a.887.887,0,0,1,0,1.775Z",
    transform: "translate(-183.789 -214.618)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459-9736",
    "data-name": "Path 3459",
    d: "M308.68,396.212H282.889a2.637,2.637,0,0,1-2.634-2.634V358.025a2.637,2.637,0,0,1,2.634-2.634H308.68a2.637,2.637,0,0,1,2.634,2.634v35.553A2.637,2.637,0,0,1,308.68,396.212Z",
    transform: "translate(-182.864 -212.178)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460-9737",
    "data-name": "Path 3460",
    d: "M354.4,397.157H328.6a2.637,2.637,0,0,1-2.634-2.634V325.248a2.637,2.637,0,0,1,2.634-2.634H354.4a2.637,2.637,0,0,1,2.634,2.634v69.275A2.637,2.637,0,0,1,354.4,397.157Z",
    transform: "translate(-181.546 -213.123)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461-9738",
    "data-name": "Path 3461",
    d: "M400.111,396.212H374.32a2.637,2.637,0,0,1-2.634-2.634V358.025a2.637,2.637,0,0,1,2.634-2.634h25.791a2.637,2.637,0,0,1,2.634,2.634v35.553a2.637,2.637,0,0,1-2.634,2.634Z",
    transform: "translate(-180.229 -212.178)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462-9739",
    "data-name": "Path 3462",
    d: "M445.827,397.53H420.036a2.58,2.58,0,0,1-2.634-2.515V312.19a2.58,2.58,0,0,1,2.634-2.515h25.791a2.58,2.58,0,0,1,2.634,2.515v82.824a2.58,2.58,0,0,1-2.634,2.515Z",
    transform: "translate(-178.912 -213.496)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463-9740",
    "data-name": "Path 3463",
    d: "M491.542,398.2H465.751a2.637,2.637,0,0,1-2.634-2.634V289.021a2.637,2.637,0,0,1,2.634-2.634h25.791a2.637,2.637,0,0,1,2.634,2.634V395.567A2.637,2.637,0,0,1,491.542,398.2Z",
    transform: "translate(-177.595 -214.167)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 5.324,
    cy: 5.324,
    r: 5.324,
    transform: "translate(107.596 121.914)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 5.324,
    cy: 5.324,
    r: 5.324,
    transform: "translate(154.629 87.306)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    cx: 5.324,
    cy: 5.324,
    r: 5.324,
    transform: "translate(201.662 121.914)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_542",
    "data-name": "Ellipse 542",
    cx: 5.324,
    cy: 5.324,
    r: 5.324,
    transform: "translate(248.695 70.445)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543",
    "data-name": "Ellipse 543",
    cx: 5.324,
    cy: 5.324,
    r: 5.324,
    transform: "translate(295.728 50.921)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464-9741",
    "data-name": "Path 3464",
    d: "M260.816,208.773l-47.144-35.312-46.5,34.829-1.064-1.42,47.565-35.628,46.92,35.144,46.627-51.024.186-.076,47.033-18.95.664,1.646-46.846,18.875Z",
    transform: "translate(-53.717 -80.341)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTrendsImage);
export default __webpack_public_path__ + "static/media/data_trends_image.d14ccd4b2ea3fecfacf984e427e8a5e9.svg";
export { ForwardRef as ReactComponent };